import { FC } from 'react';

interface Props {
  color?: string;
  className?: string;
}

const NavBasketSvg: FC<Props> = ({ className }) => {
  return (
    <svg
      className={className}
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M4.1738 2H9.82629C10.5882 2 11.2291 2.57118 11.3164 3.32806L12.1241 10.3281C12.2269 11.2187 11.5305 12 10.634 12H3.3661C2.46955 12 1.77322 11.2187 1.87599 10.3281L2.68368 3.32807C2.77102 2.57118 3.41189 2 4.1738 2ZM1.19357 3.15613C1.36824 1.64236 2.64998 0.5 4.1738 0.5H9.82629C11.3501 0.5 12.6319 1.64236 12.8065 3.15613L13.6142 10.1561C13.8197 11.9374 12.4271 13.5 10.634 13.5H3.3661C1.57301 13.5 0.180345 11.9374 0.385877 10.1561L1.19357 3.15613ZM4 4.25C4 3.83579 4.33579 3.5 4.75 3.5C5.16421 3.5 5.5 3.83579 5.5 4.25V4.5C5.5 5.32843 6.17157 6 7 6C7.82843 6 8.5 5.32843 8.5 4.5V4.25C8.5 3.83579 8.83579 3.5 9.25 3.5C9.66421 3.5 10 3.83579 10 4.25V4.5C10 6.15685 8.65685 7.5 7 7.5C5.34315 7.5 4 6.15685 4 4.5V4.25Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default NavBasketSvg;
